import { useEffect, useRef, useState } from "react";
import { StandardButton } from "../atoms/buttons"
import { HorizontalLayout, VerticalLayout } from "./layout"
import generatePalette from "../api/palette_generator";
import hex_is_light from "../api/is_light_color";

import { postAPI, updateAPI,postAPImedia ,ip} from "../api/api";

import { handleDocumentValues } from "../functions/handleTheme";

export const ThemePreviewComp = ({ data }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const saveLogo = async () => {
        if (!data?.logo_url) {
            console.error("No logo file to upload.");
            return null; 
        }
    
        const formData = new FormData();
        formData.append("file", data.logo_url);
    
        try {
            const result = await postAPImedia("api/media/add-media", formData); 
            console.log("Logo uploaded successfully!", result);
            return result.data.url;
        } catch (error) {
            console.error("Upload failed", error);
        }
    };
    const activateThemeNow = async () => {
        var uploadedLogoUrl = await saveLogo();
        console.log("logo done:", uploadedLogoUrl)
        if (!uploadedLogoUrl) {
            uploadedLogoUrl = ""
        }

        const query = "api/business/theme/create"
        const body = {
            "background_color": data?.background,
            "card_color": data?.cards,
            "border_color": data?.borders,
            "divider_color": data?.borders2,
            "sidebar_color": data?.sidebar,
            "primary_color": data?.primary,
            "text_color": data?.text,
            "card_text": data?.card_text,
            "sub_text": data?.sub_text,
            "topbar": data?.topbar,
            "border_radius": data?.border_radius,
            "employee_text": data?.employee_text,
            "logo_url": uploadedLogoUrl,
            "logo_position":data?.alignment,
            "sidebar_style":data?.sidebar_style
        }
        console.log(data)
        const post = await postAPI(query, body)
        if (post.status == "ok") {
            window.location.reload()
        }
    }

    const resetTheme = async () => {
        const query = "api/business/theme/reset"
        
        const body={}
        const post = await updateAPI(query, body)
        if (post.status == "ok") {  
            window.location.reload()
        }
    }
    return (
        <VerticalLayout className="theme-preview-comp">
            <PreviewComp data={data} isMobile={isMobile} />
            <ActionRow resetTheme={resetTheme} activateTheme={activateThemeNow} />
        </VerticalLayout>
    )
}

const PreviewComp = ({ data, isMobile, activateTheme }) => {

    const frameRef = useRef(null)

    useEffect(() => {
        const iframe = frameRef.current;
        const doc = iframe.documentElement || iframe.contentDocument || iframe.contentWindow.document;
        doc.documentElement.style.setProperty(data.key, `${data.size}rem`);
        iframe.contentWindow.postMessage({"SET_EMPLOYEE_TEXT": data.employee_text})
        iframe.contentWindow.postMessage({ SET_LOGO: data.logo_url });
        iframe.contentWindow.postMessage({ SET_ALIGNMENT: data.alignment });
        console.log("iframe data:", data)
        for (let key in data) {
            if(data[key] != null){
                handleDocumentValues(doc, key, data[key])
            }
          
        }

        

    }, [data])


    const wrapperStyle = isMobile ? {} : { width: "calc(200% - 3rem)", height: "calc(200% - 3.5rem)", transform: "scale(0.5) translateY(-50%) translateX(-50%)", position: "absolute" };



    return (
        <div className="preview-comp-holder" style={{ width: "100%", height: "100%", position: "relative", overflow: "hidden" }}>
            <iframe
                ref={frameRef}
                style={wrapperStyle}
                id="iframe-comp"
                className='preview-comp iframe-comp'
                // src={"http://localhost:3000/app?preview=true"}
                src={`${ip}/app?preview=true`}
                title="Expligo in frame"
            />
        </div>
    );
};


const ActionRow = ({ activateTheme,resetTheme }) => {

    return (
        <HorizontalLayout style={{ marginTop: "1rem" }} className="action-row-theme">
            <StandardButton onClick={activateTheme} className={"themepreview-button action"} title={"Thema activeren"} />
            <StandardButton onClick={resetTheme} className={"themepreview-button reset"} title={"Resetten"} />

        </HorizontalLayout>
    )
}

